"use client";

import { ErrorProps } from "@/types/common-props";
import { Button } from "@/components/atoms/button";

export default function HotelsListError({
  error: _error,
  reset,
}: ErrorProps) {
  return (
    <main>
      <section className="bg-white">
        <div className="layout flex min-h-screen flex-col items-center justify-center text-center text-black">
          <h1 className="mt-8 text-4xl md:text-6xl">Unable to load hotels</h1>
          <p className="mt-4 text-lg text-gray-600">
            We encountered an error while loading the hotel list. Please try
            again later.
          </p>
          <Button variant="primary" onClick={reset} className="mt-4">
            Try again
          </Button>
        </div>
      </section>
    </main>
  );
}
